module.exports = __webpack_public_path__ + "static/media/bed-ico.5318a004.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/bed-ico.png
// module id = 712
// module chunks = 0